var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('left-select',{staticClass:"left",on:{"nodeCheck":_vm.nodeCheck,"nodeClick":_vm.nodeClick}}),_vm._v(" "),_c('right-table',{ref:"rightDome",staticClass:"right",attrs:{"isAllSelection":_vm.isAllSelection}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-517981dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CourseOn/courseList/index.vue
// module id = null
// module chunks = 